import { signalStore, withMethods, withState } from '@ngrx/signals';
import { Language, UserPreference } from '@clientwire/api';
import { updateState, withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject } from '@angular/core';
import { WireApiService } from '../services';

type UserPreferencesState = {
  userId: string | null;
  preferredConversationTypeId: string | null;
  preferredLanguage: Language | null | undefined;
};

const initialState: UserPreferencesState = {
  userId: null,
  preferredConversationTypeId: null,
  preferredLanguage: null,
};

export const UserPreferencesStore = signalStore(
  { providedIn: 'root' },
  withDevtools('user-preferences-store'),
  withState(initialState),
  withMethods((store) => {
    const wireApiService = inject(WireApiService);

    return {
      setUserPreferences(userPreference: UserPreference) {
        updateState(store, 'Set user preferences', {
          userId: userPreference.userId,
          preferredConversationTypeId: userPreference.preferredConversationTypeId,
          preferredLanguage: userPreference.preferredLanguage,
        });
      },

      async updatePreferredConversationTypeId(
        userId: string,
        conversationTypeId: string | undefined
      ) {
        if (conversationTypeId != store.preferredConversationTypeId()) {
          await wireApiService.userPreferencesApi.createOrUpdateUserPreference({
            userId: userId,
            userPreferencePostRequest1: {
              preferredConversationTypeId: conversationTypeId,
              preferredLanguage: store.preferredLanguage(),
            },
          });
          updateState(store, 'Set user preferred conversation type id', {
            ...store.preferredLanguage,
            preferredConversationTypeId: conversationTypeId,
          });
        }
      },

      clearUserPreferences() {
        updateState(store, 'Clear user preferences', initialState);
        updateState(store, 'Clear entities');
      },
    };
  })
);
